export default __webpack_public_path__ + "static/turkey1-8b354f0f7d42837e3067ecc7c75db34d.webp";